// extracted by mini-css-extract-plugin
export default {"pill":"xxwPRJO_B_BofmCGciD5","selected":"TWPpbihotS2d8kO7kD3h","header":"W4fDTmlc_VctEldhRFzA","disabled":"Ic3y8r2JjPULDyqzUlJ7"};